/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ClientIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 72 73"
    onClick={props.onClick}
  >
    <g fill="none">
      <g strokeWidth="2">
        <path d="M19.5 34.566l-18 12v24h18zM49.5 22.566l-12-12-12 12v48h24zM37.5 10.566v-9M55.5 40.566l7.5-7.5 7.5 7.5v30h-15zM55.5 40.566h15M55.5 46.566h15M55.5 52.566h15M55.5 58.566h15M55.5 64.566h15M7.5 70.566v-19.5M13.5 70.566v-19.5" />
        <path d="M49.5 22.566h-24l24 12-24 12 24 12-24 12" />
      </g>
    </g>
  </svg>
);

export default ClientIcon;
